import { render, staticRenderFns } from "./NoteProduct.vue?vue&type=template&id=213963cd&"
import script from "./NoteProduct.vue?vue&type=script&lang=js&"
export * from "./NoteProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports